import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { ContentConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { ContentBasicPageService } from './api/contentBasicPage.service';
import { ContentBlogService } from './api/contentBlog.service';
import { ContentPressReleasePageService } from './api/contentPressReleasePage.service';
import { CustomMenuLinkCampaignDEService } from './api/customMenuLinkCampaignDE.service';
import { CustomMenuLinkCampaignENService } from './api/customMenuLinkCampaignEN.service';
import { CustomMenuLinkFooterService } from './api/customMenuLinkFooter.service';
import { CustomMenuLinkFooterDEService } from './api/customMenuLinkFooterDE.service';
import { CustomMenuLinkFooterFRService } from './api/customMenuLinkFooterFR.service';
import { CustomMenuLinkMainNavigationDEService } from './api/customMenuLinkMainNavigationDE.service';
import { CustomMenuLinkMainNavigationENService } from './api/customMenuLinkMainNavigationEN.service';
import { CustomMenuLinkTrendcommerceDEService } from './api/customMenuLinkTrendcommerceDE.service';
import { CustomMenuLinkTrendcommerceENService } from './api/customMenuLinkTrendcommerceEN.service';
import { FileService } from './api/file.service';
import { MediaAudioService } from './api/mediaAudio.service';
import { MediaDocumentService } from './api/mediaDocument.service';
import { MediaImageService } from './api/mediaImage.service';
import { MediaRemoteVideoService } from './api/mediaRemoteVideo.service';
import { MediaVideoService } from './api/mediaVideo.service';
import { ParagraphAccordionService } from './api/paragraphAccordion.service';
import { ParagraphAccordionItemService } from './api/paragraphAccordionItem.service';
import { ParagraphCTAService } from './api/paragraphCTA.service';
import { ParagraphDividerService } from './api/paragraphDivider.service';
import { ParagraphFormContentService } from './api/paragraphFormContent.service';
import { ParagraphFormContentItemService } from './api/paragraphFormContentItem.service';
import { ParagraphFreeTextService } from './api/paragraphFreeText.service';
import { ParagraphHeroService } from './api/paragraphHero.service';
import { ParagraphHeroSliderService } from './api/paragraphHeroSlider.service';
import { ParagraphLogoSliderService } from './api/paragraphLogoSlider.service';
import { ParagraphMediaService } from './api/paragraphMedia.service';
import { ParagraphMemberService } from './api/paragraphMember.service';
import { ParagraphMultipleColumnService } from './api/paragraphMultipleColumn.service';
import { ParagraphMultipleColumnItemService } from './api/paragraphMultipleColumnItem.service';
import { ParagraphNavigationWidgetService } from './api/paragraphNavigationWidget.service';
import { ParagraphNavigationWidgetItemService } from './api/paragraphNavigationWidgetItem.service';
import { ParagraphNewsTickerService } from './api/paragraphNewsTicker.service';
import { ParagraphNewsTickerItemService } from './api/paragraphNewsTickerItem.service';
import { ParagraphOverlayTextMediaBoxService } from './api/paragraphOverlayTextMediaBox.service';
import { ParagraphRelatedItemsService } from './api/paragraphRelatedItems.service';
import { ParagraphRelatedSolutionsService } from './api/paragraphRelatedSolutions.service';
import { ParagraphSectionHeadlineService } from './api/paragraphSectionHeadline.service';
import { ParagraphSliderService } from './api/paragraphSlider.service';
import { ParagraphSliderItemService } from './api/paragraphSliderItem.service';
import { ParagraphSmallTextMediaBoxService } from './api/paragraphSmallTextMediaBox.service';
import { ParagraphTeamService } from './api/paragraphTeam.service';
import { ParagraphTelephoneService } from './api/paragraphTelephone.service';
import { ParagraphTelephoneContainerService } from './api/paragraphTelephoneContainer.service';
import { ParagraphTestimonialService } from './api/paragraphTestimonial.service';
import { ParagraphTestimonialSliderService } from './api/paragraphTestimonialSlider.service';
import { ParagraphTextMarginalService } from './api/paragraphTextMarginal.service';
import { ParagraphTextMediaBoxService } from './api/paragraphTextMediaBox.service';
import { ParagraphWidgetService } from './api/paragraphWidget.service';
import { SearchIndexService } from './api/searchIndex.service';
import { SearchPageService } from './api/searchPage.service';
import { URLAliasService } from './api/uRLAlias.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ContentApiModule {
    public static forRoot(configurationFactory: () => ContentConfiguration): ModuleWithProviders<ContentApiModule> {
        return {
            ngModule: ContentApiModule,
            providers: [ { provide: ContentConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ContentApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ContentApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
